/**
 * Enum with all different mixpanel origins to use
 */
export const ORIGINS = {
  predictive_models: 'pms_table',
  'view-campaign': 'campaign_view',
  network: 'network',
  profile: 'profile'
};
